import {
    validateExtensions,
    validateFileSize,
 } from './_helpers';

const errorText = {
	maxsize:
		"Файл больше, чем 10Мб. Удалите его и попробуйте загрузить файл меньшего размера, чтобы отправить форму",
	type: "Ошибка. Неверный формат файла.",
};

const defaultExtensions = ['.png','.pdf', '.jpg', '.jpeg', '.doc', '.docx', '.txt', '.ppt', '.pptx']
let inputExtensions = []

if ($('.js-uploadFileInput').data('extensions')) {
    inputExtensions = $('.js-uploadFileInput').data('extensions').split(',')
}

const extensions = inputExtensions.length > 0 ? inputExtensions : defaultExtensions;
const maxFileSize = 10485760;
const uploadFileInput = $('.js-uploadFileInput');
const filesDrop = $('.js-filesDrop');

// Проверка поддержки браузером
if(typeof(window.FileReader) == 'undefined') {
    console.log('Не поддерживается браузером!');
    filesDrop.addClass('is_error_filereader');
}

// Добавляем класс hover при наведении
filesDrop.on('dragover', function(event){
    event.preventDefault();
    event.stopPropagation();
    filesDrop.addClass('is_hover');
});

// Убираем класс hover
filesDrop.on('dragleave', function(event){
    event.preventDefault();
    event.stopPropagation();
    filesDrop.removeClass('is_hover');
});

// Обрабатываем событие Drop
filesDrop.on('drop', function(event){
    const file = event.originalEvent.dataTransfer.files;

    event.preventDefault();
    event.stopPropagation();

    filesDrop.removeClass('is_hover');
    filesDrop.addClass('is_drop');
    uploadFileInput.prop('files', file).trigger('change');

    return false;
});

$(document).on('change', '.js-uploadFileInput', (event) => {
    const _this = $(event.currentTarget);
	const form = _this.parents('.js-validate');
    const cloneInput = _this.clone();
    const file = event.target.files[0];
    const currentFileDrop = _this.parents('.js-filesDrop');
    const uploadList = currentFileDrop.find('.js-uploadFileList');
    const _input = currentFileDrop.find('.fieldset-file__status')
    const _required = _input.prop('required');
    const uploadErrorText = currentFileDrop.find('.js-uploadErrorText');
    const uploadErrorLabel = currentFileDrop.find('span.label-error');
	const errorTextData = currentFileDrop.data('error-text');

	const errorTextMaxSize = errorTextData ? errorTextData : errorText.maxsize;

    if (_required) {
        currentFileDrop.addClass('required');
        _input.prop('required',false).valid();
    }

    if(validateExtensions(file, extensions) && validateFileSize(file, maxFileSize)){
        if (currentFileDrop.hasClass('one-file')) {
            appendOneFileTemplate({ file, uploadList });
        } else {
            appendFileTemplate({ input: _this, file, uploadList });
            currentFileDrop.find('label').append(cloneInput.val(''));

            $('.fieldset-file__status').prop('required', false);

            if ( $('form')[0].checkValidity() ) {

                setTimeout(function() {
                    $('.js-formSubmit').prop('disabled', false);
                }, 200);
            }
        }

        currentFileDrop.removeClass('is_error');
        uploadErrorText.text('');

    } else {
        if(!validateFileSize(file, maxFileSize)){
			appendErrorFileTemplate({ file, uploadList }, errorTextMaxSize);
        } else {
			appendErrorFileTemplate({ file, uploadList }, errorText.type);
        }
        currentFileDrop.addClass('is_error is-files-item-created');

		form.find('.fieldset-file__start .fieldset-file__input').prop('disabled', true);
		form.find('button[type="submit"]').prop('disabled', true);
		form.find('.js-formSubmit').prop('disabled', true);
    }
    uploadErrorLabel.remove();

	if (uploadList.find(".js-uploadFile").length === 3) {
		currentFileDrop.addClass("is-disabled");
	}
});

$(document).on('click', '.js-fileDelete', (event) => {
    const _this = $(event.currentTarget);
    const currentFileDrop = _this.parents('.js-filesDrop');
	const form = _this.parents('.js-validate');
    const _input = currentFileDrop.find('.fieldset-file__status');
    const element = _this.parents('.fieldset-file__active-load');
    const elements = currentFileDrop.find('.fieldset-list').children(element).length - 1;
    const parentInput = currentFileDrop.find('.js-uploadFileInput');
	const uploadList = currentFileDrop.find(".js-uploadFileList");
	const defaultInput = $('.fieldset-file__start').find('.js-uploadFileInput');

    if (currentFileDrop.hasClass('required') && (!elements)) {
        _input.prop('required', true).valid();

        $('.js-formSubmit').prop('disabled', true);
    }

    if (currentFileDrop.hasClass('one-file')) {
        parentInput.val('');
    } else {
        element.remove();
    }

	defaultInput.val('');
    element.remove();
    $('.js-filesDrop').removeClass('is-succes');

	if (uploadList.find(".js-uploadFile").length < 3) {
		filesDrop.removeClass("is-disabled");
	}

	if (uploadList.find(".fieldset-file__active-load").length < 1) {
		currentFileDrop.removeClass('is-files-item-created');
	}

	if ($('.fieldset-file__active-load.file-error').length < 1) {
		currentFileDrop.removeClass('is-error is_error');
	}

	if(form.valid() && !(uploadList.find(".fieldset-file__active-load").hasClass('file-error'))){
		form.find('.js-formSubmit, button[type="submit"]').prop('disabled', false);
	}


	form.find('.fieldset-file__start .fieldset-file__input').prop('disabled', false);

});

function appendFileTemplate({ input, file, uploadList }) {
	let i = 0;
	const fileNameSplit = file.name.split(".")
	const fileName = fileNameSplit.slice(0, fileNameSplit.length - 1).join('.');
	const fileExt = fileNameSplit[fileNameSplit.length - 1];
	const filesDropParent = uploadList.parents('.js-filesDrop');

	const loadTpl = `
		<div class="fieldset-file__active-load js-loading js-uploadFile">
			<div class="fieldset-file__percent"></div>
			<div class="fieldset-file__loading"><span></span></div>
		</div>`;
	const tpl = `
		<div class="fieldset-file__active-load js-uploadFile">
			<div class="fieldset-file__active-reset js-fileDelete"></div>
			<div class="fieldset-file__active-name">${fileName}<span class="gray">.${fileExt}</span></div>
			<div class="fieldset-file__error"></div>
		</div>`;

	uploadList.append(loadTpl);

	const timerId = setInterval(() => {
		i++;
		$(".js-loading").find(".fieldset-file__percent").text(`${i}%`);
		$(".js-loading")
			.find(".fieldset-file__loading span")
			.css("width", `${i}%`);

		if (i === 100) {
			clearInterval(timerId);
			$(".js-filesDrop").addClass("is-succes");

			$(tpl).append(input);
			$(".js-loading").remove();
			uploadList.append(tpl);
			uploadList.find(".fieldset-file__active-load:last").append(input);

			filesDropParent && filesDropParent.addClass('is-files-item-created');
		}
	}, 10);
}

function appendErrorFileTemplate({ file, uploadList }, errorText) {
	$(".js-filesDrop").addClass("is-error");

	const fileNameSplit = file.name.split(".")
	const fileName = fileNameSplit.slice(0, fileNameSplit.length - 1).join('.');
	const fileExt = fileNameSplit[fileNameSplit.length - 1];

	const tpl = `<div class="fieldset-file__active-load file-error js-uploadFile">
		<div class="fieldset-file__active-reset js-fileDelete"></div>
		<div class="fieldset-file__text">
			<div class="fieldset-file__active-name">${fileName}<span class="gray">.${fileExt}</span></div>
			<div class="fieldset-file__caption">${errorText}</div>
		</div>
	</div>`;

	uploadList.append(tpl);
}

function appendOneFileTemplate({ file, uploadList }) {
    $('.js-filesDrop').addClass('is-succes');
    const uploadFile = uploadList.find('.fieldset-file__active-load');

    const tpl = `
        <div class="fieldset-file__active-load">
            <div class="fieldset-file__active-icon">
            </div>
            <div class="fieldset-file__active-name">${file.name}</div>
            <div class="fieldset-file__active-reset js-fileDelete">
            </div>
            <div class="fieldset-file__error"></div>
        </div>
    `
    uploadFile.remove();
    uploadList.append(tpl);
}
